import { render, staticRenderFns } from "./routeConfig.vue?vue&type=template&id=38ed5a80&"
import script from "./routeConfig.vue?vue&type=script&lang=js&"
export * from "./routeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports